import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  RemittanceMallsConfig,
  RemittanceMallsConfigVariables
} from "./types/RemittanceMallsConfig";

export const remittanceMallsConfig = gql`
  query RemittanceMallsConfig(
    $first: Int
    $before: String
    $after: String
    $last: Int
    $status: String
  ) {
    malls(
      first: $first
      before: $before
      after: $after
      last: $last
      filter: { status: $status }
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          id
          name
          remittanceConfig {
            dailyNotifTimes
            codLimit
            reminderIsActive
            isEnable
            minRemittanceLimit
            enabledAt
          }
        }
      }
    }
  }
`;
export const useRemittanceMallsConfig = makeQuery<
  RemittanceMallsConfig,
  RemittanceMallsConfigVariables
>(remittanceMallsConfig);
